import { Link } from 'react-router-dom';

const LOGO = 'https://static.readdy.ai/image/1e1c36a8fe2eee6efab369c345d12000/d2de7d124fc44cc7dd03173e7e2df5a4.png';

const navLinks = [
  { label: 'El Manifiesto', href: '#manifiesto' },
  { label: 'La Cartografía', href: '#cartografia' },
  { label: 'Resonancia', href: '#resonancia' },
  { label: 'Planes de Acceso', href: '#planes' },
];

export default function Footer() {
  const handleNav = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#1A1C20] border-t border-[#F8F6F3]/5">
      {/* Main footer grid */}
      <div className="max-w-screen-xl mx-auto px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <img src={LOGO} alt="Nube Geodésica" className="h-10 w-auto object-contain mb-4" />
            <p className="text-[#F8F6F3]/40 text-sm leading-relaxed">
              Re-ingeniería Sistémica para la expansión de la conciencia humana. Arquitectura del Alma.
            </p>
            <div className="flex items-center gap-3 mt-6">
              <span className="inline-block w-2 h-2 rounded-full bg-[#8B9D83] animate-pulse" />
              <span className="text-[#8B9D83] text-xs uppercase tracking-[2px]">Red Activa</span>
            </div>
          </div>

          {/* Navigate */}
          <div>
            <p className="text-[#8B9D83] text-xs uppercase tracking-[2px] mb-5 font-semibold">Navegar</p>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => handleNav(e, link.href)}
                    className="text-[#F8F6F3]/50 hover:text-[#C97B63] text-sm transition-colors duration-300 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="#iniciar-trazado"
                  onClick={(e) => handleNav(e, '#iniciar-trazado')}
                  className="text-[#F8F6F3]/50 hover:text-[#C97B63] text-sm transition-colors duration-300 cursor-pointer"
                >
                  Iniciar Trazado
                </a>
              </li>
            </ul>
          </div>

          {/* Pillars */}
          <div>
            <p className="text-[#8B9D83] text-xs uppercase tracking-[2px] mb-5 font-semibold">Los 6 Pilares</p>
            <ul className="space-y-3">
              {[
                'Horizonte Arraigado',
                'Bio-Santuario',
                'Alquimia Mental',
                'Astrolabio Interior',
                'Maestría Multidimensional',
                'Blueprint Sistémico',
              ].map((p) => (
                <li key={p}>
                  <span className="text-[#F8F6F3]/40 text-sm">{p}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Connect */}
          <div>
            <p className="text-[#8B9D83] text-xs uppercase tracking-[2px] mb-5 font-semibold">Conectar</p>
            <ul className="space-y-3 mb-8">
              {[
                { icon: 'ri-instagram-line', label: 'Instagram', href: '#' },
                { icon: 'ri-telegram-line', label: 'Comunidad Telegram', href: '#' },
                { icon: 'ri-youtube-line', label: 'YouTube', href: '#' },
              ].map((s) => (
                <li key={s.label}>
                  <a
                    href={s.href}
                    className="flex items-center gap-2 text-[#F8F6F3]/50 hover:text-[#C97B63] text-sm transition-colors duration-300 cursor-pointer"
                    rel="nofollow"
                  >
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className={`${s.icon} text-sm`} />
                    </div>
                    {s.label}
                  </a>
                </li>
              ))}
            </ul>

            {/* Estelarte badge */}
            <div className="border border-[#C97B63]/30 rounded-lg px-4 py-3">
              <p className="text-[#C97B63] text-xs font-semibold uppercase tracking-[1px] mb-1">App Estelarte</p>
              <p className="text-[#F8F6F3]/40 text-xs leading-relaxed">
                Incluida gratis con todos los planes de acceso.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Large wordmark banner */}
      <div className="border-t border-[#F8F6F3]/5 overflow-hidden py-6 px-8">
        <div className="flex items-end justify-between">
          <p
            className="font-bold text-[#E8DCC8]/10 select-none leading-none tracking-[-4px] overflow-hidden whitespace-nowrap"
            style={{ fontSize: 'clamp(3rem, 10vw, 8rem)' }}
          >
            NUBE GEODÉSICA
          </p>
          <p className="text-[#F8F6F3]/20 text-xs text-right flex-shrink-0 ml-4">
            © {new Date().getFullYear()} Nube Geodésica.<br />
            Todos los derechos reservados.<br />
            <Link to="/admin" className="text-[#F8F6F3]/15 hover:text-[#F8F6F3]/40 transition-colors duration-200 text-[10px] mt-1 inline-block">
              Administración
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
